class CodigoCtbInfracaoTransito {
    constructor(
        {
            id = null,
            codigo_infracao_ctb = null,
            codigo_desdobramento_infracao_ctb = null,
            descricao_infracao = null,
            amparo_legal = null,
            infrator_responsavel = null,
            competencia_infracao = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,
            descricao_abreviada = null,
            descricao_ajustada = null,

            ind_competencia_estadual = null,
            ind_competencia_municipal = null,
            ind_competencia_rodoviaria = null,
            ind_exige_medicao = null,
            ind_permite_digitacao = null,

            vigencia_codigo_infracao = []
        } = {}
    ) {
        this.id = id;
        this.codigo_infracao_ctb = codigo_infracao_ctb;
        this.codigo_desdobramento_infracao_ctb = codigo_desdobramento_infracao_ctb;
        this.descricao_infracao = descricao_infracao;
        this.amparo_legal = amparo_legal;
        this.infrator_responsavel = infrator_responsavel;
        this.competencia_infracao = competencia_infracao;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;
        this.descricao_abreviada = descricao_abreviada;
        this.descricao_ajustada = descricao_ajustada;
        this.ind_competencia_estadual = ind_competencia_estadual;
        this.ind_competencia_municipal = ind_competencia_municipal;
        this.ind_competencia_rodoviaria = ind_competencia_rodoviaria;
        this.ind_exige_medicao = ind_exige_medicao;
        this.ind_permite_digitacao = ind_permite_digitacao;
        this.vigencia_codigo_infracao = vigencia_codigo_infracao;
    }
}

export default CodigoCtbInfracaoTransito;